import { Divider, Row, Switch, Layout, Typography, Flex } from "antd";
import { Field, Form, Formik } from "formik";
import { useTranslation, Translation } from "react-i18next";
import { Link } from "react-router-dom";
import Logo from "assets/images/logo_final_1_1.png";

import { Button } from "components/elements";
import { Input, Password } from "components/form";
import { AuthBackground } from "components/layouts";

import LoginSchema from "../schemas/loginSchema";
import styles from "../styles/Login.module.css";
import { Content } from "antd/lib/layout/layout";
import { Col } from "antd/lib";
import { Image } from "antd/lib";
import { Card } from "antd/lib";
import { Space } from "antd/lib";
import * as Yup from "yup";
import { useMediaQuery } from "react-responsive";
import { Footer } from "antd/es/layout/layout";

function Login({ isLoading = false, doLogin = () => { } }) {
  const { t } = useTranslation();
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
  const isOver = useMediaQuery({ maxWidth: 1000 })
  const isPortrait = useMediaQuery({ orientation: 'portrait' })
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('invalidEmail'))
      .required(t('pleaseEnterYourEmail')),
    password: Yup.string().min(8).required(t('pleaseRnterYourPassword')),
  });

  return (
    <AuthBackground AuthBackground showLanguageSwitcher >
      <Layout>
        <Content style={{
          background: 'transparent',
          justifyContent: "center",
          textAlign: "center",
          position: 'relative',
          marginTop: isTabletOrMobile ? '60px' : '20px'
        }}>
          <Row style={!isPortrait && {
            marginLeft: "30vw",
            marginRight: "30vw"
          }}>
            <Col span={22} style={{ justifyContent: "center" }}>
              <Image preview={false} width={"24vw"} src={Logo} style={{
                justifyContent: "center",
                textAlign: "center",
                margin: 30
              }} />
            </Col>
            <Col span={24}>
              {/* <span style={{
                fontSize: "6vh",
                fontWeight: "bold",
                color: "#00275A"
              }}>{t("home.headerWelcome")}</span> */}
              <Card className={styles.formContainer} styles={{ body: { padding: "0px" } }}>
                <Formik
                  initialValues={{
                    email: window.localStorage.getItem("rememberUser") || "",
                    password: "",
                    rememberMe: window.localStorage.getItem("rememberUser") ? "Y" : "N",
                  }}
                  validationSchema={LoginSchema}
                  onSubmit={doLogin}
                >
                  {({ setFieldValue, handleSubmit }) => {
                    return (
                      <Form style={{
                        // height: "50vh",
                        // maxHeight: "50vh",
                        maxWidth: "100%",
                      }} >
                        <Flex vertical style={{ paddingBottom: "2vw" }}>
                          <span className={styles.formHeader}>
                            <Translation>{(t) => t("signin.label.signin")}</Translation>
                          </span>
                          <span className={styles.subHeader} style={{ fontSize: isTabletOrMobile ? "3vw" : "1vw" }}>
                            <Translation>{(t) => t("signin.label.sub_header")}</Translation>
                          </span>
                        </Flex>
                        <Flex vertical style={{ display: "flex", flexDirection: "column", gap: "2vw" }}>
                          <Flex>
                            <Input
                              name="email"
                              size="large"
                              type="text"
                              placeholder={t("signin.placeholders.email")}
                              className={styles.input}
                            />
                          </Flex>
                          <Flex>
                            <Input
                              name="password"
                              size="large"
                              type="password"
                              placeholder={t("signin.placeholders.password")}
                              className={styles.input}
                            />
                          </Flex>
                        </Flex>
                        <Row align="middle" justify="space-between"
                          style={{
                            marginTop: 20,
                            width: "100%",

                          }} direction="vertical" size={20}>
                          <Field name="rememberMe">
                            {({ field }) => {
                              return (
                                <Row align="middle">
                                  <Switch
                                    style={{
                                      width: "10%",
                                      // height: "100%"
                                    }}
                                    id={field.name}
                                    name={field.name}
                                    onBlur={field.onBlur}
                                    onChange={(e) => {
                                      setFieldValue(field.name, e ? "Y" : "N");
                                    }}
                                    value="Y"
                                    checked={field.value === "Y"}
                                  />
                                  <label
                                    className={styles.rememberMe}
                                    htmlFor={field.name}
                                  >
                                    <Typography.Text strong={true} style={{ fontSize: isTabletOrMobile ? "2vw" : "0.8vw" }}>
                                      {t("signin.label.remember_me")}
                                    </Typography.Text>
                                  </label>
                                </Row>
                              );
                            }}
                          </Field>
                          <Link
                            style={{
                              fontSize: isTabletOrMobile ? "2vw" : "0.8vw",
                              color: "#1677ff"
                            }} to="/forgot_password">
                            <h4 >
                              {t("signin.label.forgot_password")}
                            </h4>
                          </Link>
                        </Row>
                        <Space style={{
                          marginTop: 20,
                          width: "100%"
                        }} direction="vertical" size={50}>
                          <Button
                            className={styles.button}
                            disabled={isLoading}
                            htmlType="submit"
                            size="large"
                          >
                            <span style={{ fontSize: isTabletOrMobile ? "2vw" : "0.8vw" }}>
                              <Translation>
                                {(t) => t("signin.entity").toUpperCase()}
                              </Translation>
                            </span>
                          </Button>
                        </Space>
                        <Divider style={{
                          margin: "5",
                          fontSize: "2vh"
                        }}>
                          <Translation >{(t) => t("common.or")}</Translation>
                        </Divider>
                        <Link to="/sign_up">
                          <Button
                            className={styles.button2}
                            type="default"
                            size="large"
                            htmlType="button"
                          >
                            <span>
                              <Translation>
                                {(t) => t("signup.entity").toUpperCase()}
                              </Translation>
                            </span>
                          </Button>
                        </Link>
                      </Form>
                    );
                  }}
                </Formik>

              </Card>
            </Col>
          </Row>


        </Content>
        <Footer style={{ backgroundColor: "transparent" }}>
          <Flex vertical align="center">
            <span style={{ color: "#757575" }}>{t("common.version")} 1.3.4</span>
            <span style={{ color: "#757575" }}>
              Copyright (c) by Bright Expert Company Limited. All Rights Reserved.
            </span>
          </Flex>
        </Footer>
      </Layout>
    </AuthBackground>

  );

}

export default Login;
